import { Component, Inject, Input, LOCALE_ID } from '@angular/core';
import { FormStyle, getLocaleDayNames, TranslationWidth } from '@angular/common';

@Component({
  selector: 'app-agenda-header-dia',
  templateUrl: './agenda-header-dia.component.html',
  styleUrls: ['./agenda-header-dia.component.scss']
})
export class AgendaHeaderDiaComponent {
  @Input() numero!: string;
  @Input() quantidadeHoras = 8;
  @Input() index?: number;
  @Input() selectedDate!: Date;
  @Input() horas!: number;

  // nomes vêm do locale (domingo = 0), não de lista digitada à mão: a lista antiga tinha "Sabado" sem acento
  private readonly nomesDias: ReadonlyArray<string>;

  constructor(@Inject(LOCALE_ID) locale: string) {
    // "segunda-feira" vira "segunda": a coluna do dia é estreita e o cabeçalho sempre usou o nome curto
    this.nomesDias = getLocaleDayNames(locale, FormStyle.Standalone, TranslationWidth.Wide).map((nome) =>
      nome.replace(/-feira$/, '')
    );
  }

  get diaAtual(): boolean {
    const currentDate = new Date();
    const inicioSemana = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - currentDate.getDay()
    );

    const fimSemana = new Date(inicioSemana.getFullYear(), inicioSemana.getMonth(), inicioSemana.getDate() + 6);

    return this.selectedDate.getTime() > inicioSemana.getTime() && this.selectedDate.getTime() < fimSemana.getTime();
  }

  get dia(): string {
    // fora de 0..6 cai em domingo, como o switch antigo fazia no default
    return this.nomesDias[this.index ?? 0] ?? this.nomesDias[0];
  }
}
